/*
 * File: /src/services/taskServices.js
 * Created Date: Tuesday August 17th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 17th August 2021 3:51:32 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_TASKS_PATH } from '../constants';

export default {
  /**
   * Fetch Task by Id
   */
  fetchTask(id) {
    return authedAxios.get(AD_BASE_TASKS_PATH + id);
  },

  fetchTaskPriorities() {
    return authedAxios.get(AD_BASE_TASKS_PATH + 'task-priorities', {
    });
  },

  /**
   * Fetch Task Items
   */
  fetchTasks(contactId, userId, queueId, incomplete, dueToday, priorityFilter, limit, sort, after, before, offset) {
    let filters = [];
    let params = {};
    if (contactId) {
      filters.push(`contact_id:eq:${contactId}`);
    }
    if (userId) {
      filters.push(`user_id:eq:${userId}`);
    }
    if (queueId) {
      filters.push(`queue_id:eq:${queueId}`);
    }
    if (priorityFilter != undefined) {
      filters.push(`priority:eq:${priorityFilter}`);
    }
    if (after) {
      filters.push(`id:gt:${after}`);
    }
    if (before) {
      filters.push(`id:lt:${before}`);
    }
    if (incomplete != undefined) {
      if (incomplete) {
        filters.push(`completed_at:null`);
      }
    }
    if (dueToday != undefined) {
      if (dueToday) {
        const bod = new Date();
        bod.setHours(0);
        bod.setMinutes(0);
        bod.setSeconds(0);
        const eod = new Date(bod);
        eod.setDate(eod.getDate() + 1);
        const tmp = eod.toISOString().replace(/:/g, '%3a');
        const tmp2 = bod.toISOString().replace(/:/g, '%3a');
        filters.push(`due_date:lte:${tmp}:and`);
        // filters.push(`followup_at:gte:${tmp2}:and`);
        filters.push(`completed_at:null:null:and`);
      }
    }
    if (filters.length) {
      params.filter = filters;
    }
    if (limit) {
      params.limit = limit;
    }
    if (sort) {
      params.sort = sort;
    }
    if (offset) {
      params.offset = offset
    }
    return authedAxios.get(AD_BASE_TASKS_PATH, {
      params,
    });
  },

  /**
   * Update Task
   */
  updateTask(id, body) {
    return authedAxios.put(AD_BASE_TASKS_PATH + id, body);
  },

  createTask(body) {
    return authedAxios.post(AD_BASE_TASKS_PATH, body);
  },
  assign(taskId, userId) {
    const payload = { user_id: userId };
    return authedAxios
      .put(AD_BASE_TASKS_PATH + 'assign/' + taskId, payload)
      .then((r) => r.data);
  },

  completeTask(id) {
    return authedAxios.put(AD_BASE_TASKS_PATH + 'markcompleted/' + id);
  },

  /**
   * Delete Task
   */
  deleteTaskById(id) {
    return authedAxios.delete(AD_BASE_TASKS_PATH + id);
  },
};
